module.exports = __webpack_public_path__ + "img/i_homework-status-unfinished.483b5a04.svg";